import { render } from "./DetailRoute.vue?vue&type=template&id=46fee57a"
import script from "./DetailRoute.vue?vue&type=script&lang=js"
export * from "./DetailRoute.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__